import styled from 'styled-components';
import { Type } from '@spotify-internal/encore-web';
import LegalTerms from '../../atoms/LegalTerms';
import { spacer4, spacer8, spacer12, spacer16, spacer20, screenSmMin, opacityBlack10, gray85, white, blue, heading3FontSize, body1FontSize, } from '@spotify-internal/encore-foundation';
export const CardContainer = styled.div `
  margin: 0 auto;
  max-width: 580px;
`;
export const AboveCard = styled.div `
  margin: 0 0 ${spacer16};
  display: flex;
  justify-content: space-between;
  color: ${({ color }) => (color ? color : `${white}`)};
  font-size: ${body1FontSize};

  [href]:hover {
    color: ${({ color }) => (color ? color : `${white}`)};
  }
`;
export const Card = styled.article `
  color: ${({ color }) => (color ? color : `${white}`)};
  ${({ background }) => background
    ? `background-color: ${background};
     padding: ${spacer16};
     border: 1px solid ${gray85};
     border-radius: 7px;
     box-shadow: 0 1px 1px ${opacityBlack10};

     @media (min-width: ${screenSmMin}) {
      padding: ${spacer16} ${spacer20};
     }`
    : ''};
`;
export const Promotion = styled(Type.p) `
  background-color: ${blue};
  color: ${white};
  border-radius: 4px;
  padding: ${spacer4} ${spacer8};
  display: inline-block;
  margin-bottom: ${spacer12};
  margin-block-start: 0;
`;
export const Text = styled(Type.p) `
  margin: 0;
  padding: 0;
  font-size: ${body1FontSize};
`;
export const Header = styled(Type.h2) `
  margin: 0 0 ${spacer8};
  padding: 0;
  font-size: ${heading3FontSize};
`;
export const LegalText = styled(LegalTerms) `
  margin: ${spacer12} 0 0;
  padding: 0;

  a {
    color: inherit;
    text-decoration: underline;
    font-weight: bold;
  }
`;
//# sourceMappingURL=components.js.map